<template>
    <div class="widget-form-container">

        <!-- 以el-form为起始 -->
        <el-form :label-position="data.labelPosition || 'top'"
                 :label-width="data.labelWidth ? `${data.labelWidth}px` : '100px' "
                 :label-suffix="data.labelSuffix"
                 :model="form"
                 ref="widgetForm"
                 size="small">
            <el-row :gutter="data.gutter">

                <!-- animation: ms, 动画速度运动项目排序时，' 0 ' -没有动画。 -->
                <draggable class="widget-form-list"
                           :list="data.column"
                           :group="{ name: 'form' }"
                           ghost-class="ghost"
                           :animation="300"
                           @add="handleWidgetAdd"
                           @end="$emit('change')">

                    <template v-for="(column, index) in data.column">

                        <div class="widget-form-table"
                             v-if="column.type == 'dynamic'"
                             :key="index"
                             :class="{ active: selectWidget.prop == column.prop }"
                             @click="handleSelectWidget(index)">

                            <widget-form-table :data="data"
                                               :column="column"
                                               :index="index"
                                               :select.sync="selectWidget"
                                               @change="$emit('change')"></widget-form-table>
                        </div>

                        <div class="widget-form-group"
                             v-else-if="column.type == 'group'"
                             :key="index"
                             :class="{ active: selectWidget.prop == column.prop }"
                             @click="handleSelectWidget(index)">
                            <widget-form-group :data="data"
                                               :column="column"
                                               :index="index"
                                               :select.sync="selectWidget"
                                               @change="$emit('change')">
                            </widget-form-group>
                        </div>

                        <el-col v-else
                                :key="index"
                                :md="column.span || 12"
                                :xs="24"
                                :offset="column.offset || 0">
                            <el-form-item class="widget-form-item"
                                          :label="generateLabel(column)"
                                          :labelWidth="column.labelWidth"
                                          :prop="column.prop"
                                          :class="{ active: selectWidget.prop == column.prop, 'required': column.required }"
                                          @click.native="handleSelectWidget(index)">

                                <widget-form-item :item="column"
                                                  :params="column.params"></widget-form-item>

                                <el-button title="删除"
                                           @click.stop="handleWidgetDelete(index)"
                                           class="widget-action-delete"
                                           v-if="selectWidget.prop == column.prop"
                                           circle
                                           plain
                                           size="small"
                                           type="danger">
                                    <i class="iconfont icon-delete"></i>
                                </el-button>
                                <el-button title="复制"
                                           @click.stop="handleWidgetClone(index)"
                                           class="widget-action-clone"
                                           v-if="selectWidget.prop == column.prop"
                                           circle
                                           plain
                                           size="small"
                                           type="primary">
                                    <i class="iconfont icon-copy"></i>
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </template>
                </draggable>
            </el-row>
        </el-form>

    </div>
</template>

<script>
    import WidgetFormItem from './WidgetFormItem'
    import WidgetFormTable from './WidgetFormTable'
    import WidgetFormGroup from './WidgetFormGroup'
    import Draggable from 'vuedraggable'

    export default {
        name: 'widget-form',
        components: {Draggable, WidgetFormItem, WidgetFormTable, WidgetFormGroup},
        props: ['data', 'select'],
        data() {
            return {
                selectWidget: this.select,
                form: {},
            }
        },


        methods: {
            generateLabel(column) {
                let routerMap = this.$routerParamsDecrypt(this.$route.params.routeParams || {});
                if (!routerMap.id) {
                    if (column.originLabel) {
                        return column.orderNumber + "、" + column.originLabel;
                    } else {
                        return column.orderNumber + "、" + column.label;
                    }
                } else {
                    let index = column.label.indexOf('、');
                    let newLabel = column.label.substring(index+1, column.label.length);
                    return column.orderNumber + "、" + newLabel;
                }

                //
                // if (routerMap.id) {
                //     column.originLabel = column.label;
                //     if (column.originLabel != undefined) {
                //         column.label = column.orderNumber + "、" + column.originLabel;
                //     } else {
                //         column.label = column.orderNumber + "、" + column.label;
                //     }
                // }else{
                //
                // }
            },

            handleSelectWidget(index) {
                this.selectWidget = this.data.column[index]
            },

            handleWidgetAdd(evt) {
                const newIndex = evt.newIndex
                const data = this.deepClone(this.data.column[newIndex])
                if (!data.prop) data.prop = Date.now() + '_' + Math.ceil(Math.random() * 99999)
                delete data.icon
                delete data.subfield
                if (data.type == 'title') {
                    delete data.label
                    this.form[data.prop] = data.value
                }
                this.$set(this.data.column, newIndex, data)
                this.handleSelectWidget(newIndex)

                this.$emit("change")
            },

            handleWidgetDelete(index) {
                if (this.data.column.length - 1 === index) {
                    if (index === 0) this.selectWidget = {}
                    else this.handleSelectWidget(index - 1)
                } else this.handleSelectWidget(index + 1)

                this.$nextTick(() => {
                    this.data.column.splice(index, 1)
                    this.$emit("change")
                })
            },

            handleWidgetClone(index) {
                //深拷贝对象，然后给定prop值，然后将内容区角标替换
                let cloneData = this.deepClone(this.data.column[index])
                cloneData.prop = Date.now() + '_' + Math.ceil(Math.random() * 99999)
                this.data.column.splice(index, 0, cloneData)
                this.$nextTick(() => {
                    this.handleSelectWidget(index + 1)
                    this.$emit("change")
                })
            },

        },
        watch: {

            select(val) {
                this.selectWidget = val
            },
            selectWidget: {
                handler(val) {
                    this.$emit('update:select', val)
                },
                deep: true
            },
            data: {
                handler(val) {
                    if (val.column && val.column.length > 0) {
                        val.column.forEach((item, index) => {
                            item.orderNumber = index + 1;
                        })
                    }
                },
                immediate: true,
                deep: true
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/avue/main-component/WidgetForm.vue